// extracted by mini-css-extract-plugin
export var navbarSubLink = "G_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "G_t8 d_f0 d_dB";
export var subPageLink = "G_gf d_gf";
export var burger = "G_wl";
export var sublinkSize = "G_wm";
export var linkSize = "G_wn";
export var Link = "G_sZ y_sZ y_sf y_sz";